<template>
  <div>
    <v-main>
      <v-container fluid>
        <app-headline :title="title" />

        <v-row>
          <v-col cols="12">
            <v-card
              class="pa-6"
              :class="{ 'px-12': $vuetify.breakpoint.smAndUp }"
            >
              <v-row class="pa-0 ma-0">
                <v-col class="pa-0 ma-0">
                  <history-table
                    :headers="headers"
                    :items="items"
                    :loading="loading"
                  />
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import HistoryTable from '@/components/history/HistoryTable.vue'

export default {
  components: {
    HistoryTable
  },

  data() {
    return {
      loading: true,
      positionHistoryList: []
    }
  },

  computed: {
    title() {
      return 'ประวัติการทำงาน'
    },

    headers() {
      return [
        {
          text: 'วันเริ่มต้น',
          value: 'employeeAssignDateText'
        },
        {
          text: 'วันสิ้นสุด',
          value: 'employeeEndDateText'
        },
        {
          text: 'ประเภทคำสั่ง',
          value: 'referenceDocumentTypeName'
        },
        {
          text: 'ประเภท',
          value: 'employeeTypeName'
        },
        {
          text: 'ตำแหน่ง',
          value: 'positionName'
        },
        {
          text: 'ระดับ',
          value: 'classAllType'
        },
        {
          text: 'เงินเดือน',
          value: 'currentSalaryRateText'
        },
        {
          text: 'เงินอื่นๆ',
          value: 'otherMoney'
        },
        {
          text: 'สังกัด',
          value: 'organizationFullName'
        },
        {
          text: 'เอกสาร',
          value: 'detail'
        },
        {
          text: 'สถานะ',
          value: 'workHistoryStatusName'
        },
        {
          text: 'ตรวจสอบ',
          value: 'requestChangeFlag',
          meta: 'requestChangeFlag'
        }
      ]
    },

    items() {
      const lang = this.$root.$i18n.locale
      return this.positionHistoryList.map(item => {
        item.referenceDocumentTypeName =
          item[`referenceDocumentTypeName${lang}`]
        item.employeeTypeName = item[`employeeTypeName${lang}`]
        item.organizationFullName = item[`organizationFullName${lang}`]

        item.currentSalaryRateText = this.$currencyFilter(
          item.currentSalaryRate
        )

        item.employeeAssignDateText =
          lang === 'Tha'
            ? this.$dateFormatByLang(item.employeeAssignDate, {
                format: 'DD MMMM YYYY',
                addUnit: 'y',
                addValue: 543
              })
            : this.$dateFormat(item.employeeAssignDate, {
                format: 'DD MMMM YYYY',
                locale: 'en'
              })
        item.employeeEndDateText =
          lang === 'Tha'
            ? this.$dateFormatByLang(item.employeeEndDate, {
                format: 'DD MMMM YYYY',
                addUnit: 'y',
                addValue: 543
              })
            : this.$dateFormat(item.employeeEndDate, {
                format: 'DD MMMM YYYY',
                locale: 'en'
              })
        return item
      })
    }
  },

  async mounted() {
    this.positionHistoryList = (await this.apiGetHistoryWorks()) || []
    this.loading = false
  },

  methods: {
    async apiGetHistoryWorks() {
      try {
        const res = await this.$store.dispatch('history/getWorks', this.$guid)
        return res.data?.data?.positionHistoryList || []
      } catch (e) {
        console.log(e.response || e)
      }
    }
  }
}
</script>
